import { Fragment, useContext } from 'react'

import { Context as UsageContext } from 'Root/App/Contexts/Usage'
import Link from 'Root/Component/Link'

interface Props {
  children: React.ReactNode | React.ReactNode[]
  slug: string
}

const PageLinkWrapper = ({ children, slug }: Props) => {
  const useCase = useContext(UsageContext)

  if (useCase === 'card') {
    return <Link to={`/c/${slug}`}>{children}</Link>
  }

  return <Fragment>{children}</Fragment>
}

export default PageLinkWrapper
